import { render, staticRenderFns } from "./EditFollowRecord.vue?vue&type=template&id=8a6a9422&scoped=true&"
import script from "./EditFollowRecord.vue?vue&type=script&lang=js&"
export * from "./EditFollowRecord.vue?vue&type=script&lang=js&"
import style0 from "./EditFollowRecord.vue?vue&type=style&index=0&id=8a6a9422&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6a9422",
  null
  
)

export default component.exports